import GoalError from './GoalError';
class MonthlyInvestmentCapacityMustBeMoreThanZero extends GoalError {
    constructor(options) {
        super('Available funds are less than or equal to zero when the goal plan is FUNDS', options);
    }
}
export default MonthlyInvestmentCapacityMustBeMoreThanZero;
